module.exports = __webpack_public_path__ + "static/img/jp9.67cb7cf2.png";